import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { filterCommonAttributes } from '../../ai-answer-dialog/analytics-helpers';
import { type commonAttributesType } from '../../ai-answer-dialog/types';

export const onClickDisableDefinition = (props: commonAttributesType): AnalyticsEventPayload => ({
	action: 'clicked',
	actionSubject: 'aiDefinitionsDisableDefinition',
	source: 'viewPageScreen',
	eventType: 'ui',
	attributes: {
		...filterCommonAttributes(props),
	},
});
